import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  follow?: boolean
}

const Side = ({ children, follow }: Props) => {
  return (
    <div
      className={clsx(
        'flex w-full max-w-[20rem] basis-[20rem] flex-col gap-y-4',
        follow && 'sticky top-20'
      )}
    >
      {children}
    </div>
  )
}

export default Side
